function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "1kgma",
  d: "M279.207 860.296a.953.953 0 0 0-.707-.296.991.991 0 0 0-.718.296 1.022 1.022 0 0 0-.292.73v13.476l-2.773-2.813a.953.953 0 0 0-.707-.297.991.991 0 0 0-.718.297 1.022 1.022 0 0 0-.292.729c0 .28.097.52.292.717l4.49 4.557a.972.972 0 0 0 .718.308.935.935 0 0 0 .707-.308l4.49-4.557a.962.962 0 0 0 .303-.717 1 1 0 0 0-.303-.73.953.953 0 0 0-.707-.296.991.991 0 0 0-.718.297l-2.762 2.813v-13.477a1 1 0 0 0-.303-.729z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-273 -860)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#89899e",
  xlinkHref: "#1kgma"
})));

var SvgArrowDownIcon = function SvgArrowDownIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowDownIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-down-icon.6de0056d.svg";
export { ForwardRef as ReactComponent };